import React, { useContext } from "react";
import { familyDistanceList } from "../../../../../../domain/assessment/FamilyDistance";
import { lifeStatusList } from "../../../../../../domain/assessment/LifeStatus";
import { BathAtHomeList } from "../../../../../../domain/assessment/BathAtHome";
import { AssessmentInfoContext } from "../../../../../provider/CareRecipientConfigAssessmentInfoProvider";
import { InputSelectBox } from "../../../../common/input/InputSelectBox";
import { InputTextBox } from "../../../../common/input/InputTextBox";

export const CareRecipientDetail = React.memo(function CareRecipientDetail() {
    const {
        height,
        handleHeightChanged,
        weight,
        handleWeightChanged,
        weekdayLifeStatus,
        handleWeekdayLifeStatusChanged,
        holidayLifeStatus,
        handleHolidayLifeStatusChanged,
        familyDistance,
        handleFamilyDistanceChanged,
        bathAtHome,
        handleBathAtHomeStatusChanged
    } = useContext(AssessmentInfoContext);

    return (
        <div className={"category"}>
            <div className={"title"}>基本情報</div>
            <div className="body">
                <div className="content">
                    <div className="label">身体情報</div>
                    <div className="with_unit_row">
                        <div className="with_unit">
                            <div className="physical">
                                <div className="physical__label">身長</div>
                                <InputTextBox placeholder={"例： 165"} value={height} handleTextChanged={handleHeightChanged} />
                                <span className="unit">cm</span>
                            </div>
                        </div>
                        <div className="with_unit">
                            <div className="physical">
                                <div className="physical__label">体重</div>
                                <InputTextBox placeholder={"例： 70"} value={weight} handleTextChanged={handleWeightChanged} />
                                <span className="unit">kg</span>
                            </div>
                        </div>
                    </div>
                </div>
                <hr className="border"/>
                <div className="content">
                    <div className="label">生活状況</div>
                    <div className="with_unit_row">
                        <div className="with_unit">
                            <div className="life_status">
                                <div className="life_status__label">平日</div>
                                <InputSelectBox value={weekdayLifeStatus} list={lifeStatusList} handleSelectBoxChanged={handleWeekdayLifeStatusChanged} />
                            </div>
                        </div>
                        <div className="with_unit">
                            <div className="life_status">
                                <div className="life_status__label">休日</div>
                                <InputSelectBox value={holidayLifeStatus} list={lifeStatusList} handleSelectBoxChanged={handleHolidayLifeStatusChanged} />
                            </div>
                        </div>
                    </div>
                </div>
                <hr className="border"/>
                <div className="content">
                    <div className="label">入浴状況</div>
                    <div className="with_unit_row">
                        <div className="with_unit">
                            <div className="life_status">
                                <div className="life_status__label">自宅での入浴</div>
                                <InputSelectBox value={bathAtHome} list={BathAtHomeList} handleSelectBoxChanged={handleBathAtHomeStatusChanged} />
                            </div>
                        </div>
                    </div>
                </div>
                <hr className="border"/>
                <div className="content">
                    <div className="label">相談相手</div>
                    <div className="with_unit_row">
                        <div className="with_unit">
                            <div className="family_distance">
                                <div className="family_distance__label">相談相手となるご家族等（主たる1名）</div>
                                <div>
                                    <InputSelectBox value={familyDistance} list={familyDistanceList} handleSelectBoxChanged={handleFamilyDistanceChanged} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});
